module.exports = __webpack_public_path__ + "8c98616e9f1b5e702576046b4b942658.png";